import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ToastBody, ToastStyle } from "@waytek/MobiusOverrides/Toast/Toast";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import parse from "html-react-parser";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

export interface OrderDetailsTitleStyles {
    wrapper?: InjectableCss;
}

export const titleStyles: OrderDetailsTitleStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
            padding: 0;
            width: 100%;
            max-width: 100%;
            box-shadow: none;

            & > div {
                box-shadow: none;

                ${mediaQueriesBP.minLG} {
                    max-width: 340px;
                    margin-left: 50px;
                }

                ${mediaQueriesBP.maxLG} {
                    width: 100%;
                    max-width: 100%;
                    margin-top: 40px;
                    margin-left: 0;
                }

                ${mediaQueriesBP.maxMD} {
                    width: 100%;
                    max-width: 100%;
                    margin-top: 20px;
                    margin-left: 0;
                }
            }
        `,
    },
};

const styles = titleStyles;

const SectionTitle: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <ToastStyle
                transitionState="entered"
                transitionLength={0}
                messageType="warning"
                data-test-selector="AccountSettings_Message"
            >
                <ToastBody data-id="toast-body">
                    <Typography>{parse(fields.content, parserOptions)}</Typography>
                </ToastBody>
            </ToastStyle>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SectionTitle,
    definition: {
        allowedContexts: ["AccountSettingsPage"],
        group: "Account Settings",
        displayName: "Account Settings Message",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
